module.exports = __webpack_public_path__ + "img/pc_contact.fc37a83.webp";